/* Forged Racing — product page.
   Gallery (thumb switch, arrows, zoom modal), variant selection
   (match options → variant, update price/availability/URL), qty, add to cart. */
(function () {
  'use strict';

  function init() {
    var pdp = document.querySelector('[data-frg-pdp]');
    if (!pdp) return;

    /* ---------- variants ---------- */
    var variants = [];
    var dataEl = pdp.querySelector('[data-frg-variants]');
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    /* ROUND 30: both declared up here on purpose, not beside the quantity
       block further down. updateVariant() runs during init and calls
       applyCap(), which reads `qty` — a `var` declared later hoists as
       undefined, so the first cap check would have compared against undefined.
       Same class of ordering bug as the Round 23 gallery handle. */
    var curVariant = null;
    var qty = 1;

    var priceEl = pdp.querySelector('[data-frg-price]');
    var compareEl = pdp.querySelector('[data-frg-compare]');
    var pillEl = pdp.querySelector('[data-frg-pill]');
    /* ROUND 88: product tagged "preorder" (case-insensitive), emitted by
       sections/forged-product.liquid. Part of the one pre-order rule. */
    var PREORDER_TAG = pdp.dataset.frgPreorderTag === 'true';
    var addBtn = pdp.querySelector('[data-frg-pdp-add]');
    var addLabel = pdp.querySelector('[data-frg-add-label]');

    /* ROUND 23: the gallery's show() is declared inside the `if (gallery)`
       block below and this file is strict-mode, so a block-scoped function
       declaration is NOT reachable from updateVariant(). Hoisting a handle
       here is what lets variant selection drive the media. Assigned in the
       gallery block; the initial updateVariant() call happens after that
       block runs, so first paint corrects the media too. */
    var showMedia = null;

    function selectedOptions() {
      var opts = [];
      pdp.querySelectorAll('[data-frg-option-index]').forEach(function (row) {
        var idx = parseInt(row.dataset.frgOptionIndex, 10);
        var pill = row.querySelector('.frg-pdp__opt-pill.is-active');
        var sel = row.querySelector('[data-frg-opt-select]');
        opts[idx] = pill ? pill.dataset.frgValue : (sel ? sel.value : null);
      });
      return opts;
    }

    function matchVariant(opts) {
      /* Round 17 (item I): a single-variant "Default Title" product renders
         no [data-frg-option-index] rows at all (sections/forged-product.liquid
         wraps the whole picker in `unless product.has_only_default_variant`),
         so selectedOptions() returns []. Matching [] against v.options ===
         ["Default Title"] always failed, hitting the "no match" branch below
         and forcing the button to disabled + "Unavailable" on every page
         load for every single-variant product in the catalog — regardless of
         real stock. The stock badge is server-rendered separately and was
         never affected, which is why only the button showed the wrong state. */
      if (variants.length === 1) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return String(o) === String(opts[i]); });
      });
    }

    /* ROUND 30 (Emirali: "if something only has a certain amount in stock dont
       allow them to add more then the amount we have").

       Returns the max purchasable quantity for a variant, or null meaning NO
       CAP. Every branch that returns null is deliberate:

         !v.tracked          Untracked inventory. inventory_quantity is
                             meaningless for these — baja-s2-motoparty-tint and
                             baja-squadron-tint have every variant untracked
                             with stale NEGATIVE quantities. Capping to that
                             number would make them unbuyable. The gate matches
                             the low-stock branch above, which reads the same
                             Liquid-side `inventory_management != blank`.
         policy 'continue'   Deliberately oversellable — pre-orders and
                             backorders. 28 products carry a pre-order variant;
                             capping them would kill every one.
         n < 1 or NaN        Fail OPEN. A cap of 0 or a negative would render
                             the product unbuyable, which is far worse than
                             letting Shopify reject at checkout — and Shopify
                             enforces the real limit server-side anyway. */
    function capFor(v) {
      if (!v || !v.tracked) return null;
      if (v.policy === 'continue') return null;
      var n = parseInt(v.qty, 10);
      if (!isFinite(n) || n < 1) return null;
      return n;
    }

    function updateVariant() {
      var opts = selectedOptions();
      var v = matchVariant(opts);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) { addLabel.textContent = 'Unavailable'; }
        /* ROUND 70 — clear the notice on the NO-MATCH path too.

           Caught in verification, not by reading. This product's option values
           differ per colour: Chrome Silver's fitment reads "Rear Brake (Left)
           (Pre-Order)" while Glossy Black's reads "Rear Brake (Left)". Picking
           the other colour therefore composes a combination that does not
           exist, and this branch returns BEFORE the backorder code below — so
           the notice stayed on screen, still promising a ship window, for a
           variant the customer cannot even buy. Hiding it here is the honest
           state: nothing is selected, so nothing is claimed. */
        var boNoMatch = document.querySelector('[data-frg-backorder-notice]');
        if (boNoMatch) { boNoMatch.hidden = true; }
        /* ROUND 88 T2: nothing selected, so no ship claim either. */
        document.querySelectorAll('[data-frg-ship-claim]').forEach(function (el) { el.hidden = true; });
        return;
      }
      curVariant = v;
      /* ROUND 85 T4 — keep the payment-terms form on the selected variant.
         Shopify's payment terms element re-prices on a change event from the
         form's id input, so the event is dispatched only on a real change. */
      pdp.querySelectorAll('[data-frg-variant-input]').forEach(function (inp) {
        if (String(inp.value) !== String(v.id)) {
          inp.value = v.id;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      /* Re-cap on every variant switch — different variants, different stock.
         Clamp a quantity the shopper already chose under the old variant. */
      applyCap();
      pdp.dataset.frgVariant = v.id;
      if (priceEl) {
        priceEl.textContent = v.price;
        priceEl.classList.toggle('is-sale', v.on_sale);
      }
      /* ROUND 85 T3 — struck price and pill move TOGETHER, from the same
         variant. The pill used to be server-rendered once and never updated,
         so switching to a non-sale variant hid the struck price and left
         "-50%" behind. Same rounding as the Liquid: round(diff * 100 / was). */
      if (compareEl) { compareEl.textContent = v.on_sale ? v.compare_at : ''; compareEl.hidden = !v.on_sale; }
      if (pillEl) {
        var wasCents = parseInt(v.compare_cents, 10);
        /* R87 T3: hidden when the discount rounds below 1% — never "-0%". */
        var pillPct = wasCents > 0 ? Math.round((wasCents - v.price_cents) * 100 / wasCents) : 0;
        var showPill = v.on_sale && wasCents > 0 && pillPct >= 1;
        pillEl.textContent = showPill ? '-' + pillPct + '%' : '';
        pillEl.hidden = !showPill;
      }
      /* ROUND 88 — ONE pre-order rule, mirroring snippets/forged-variant-state
         exactly so first paint and variant switching cannot disagree:

           not available             -> sold out. This includes variants whose
                                        NAME says "(Pre-Order)" but sit on DENY
                                        at 0: Shopify will not sell them, so
                                        they are not pre-orders.
           product tagged "preorder" -> pre-order (every buyable variant)
           tracked + CONTINUE + qty <= 0 -> pre-order (the old R70 backorder)

         The tracked test stays load-bearing: untracked variants here carry
         stale negative quantities (Round 30). No ship date or window is shown
         for a pre-order — the label is the plain word "Pre-order". */
      var isPreorder = !!(v.available && (PREORDER_TAG ||
                         (v.tracked && v.policy === 'continue' && v.qty <= 0)));

      if (addBtn) { addBtn.disabled = !v.available; }
      if (addLabel) {
        addLabel.textContent = !v.available ? 'Sold out'
                             : isPreorder   ? 'Pre-order'
                             : 'Add to cart';
      }

      /* ROUND 23: show the selected variant's own photo. Colourway products
         here assign a distinct image per variant, but nothing was switching
         the media — the swatch changed price and availability while the
         picture stayed on the first image, so a buyer choosing "Honda Red"
         was still looking at White/Chrome. Guarded on a real index: a variant
         with no image of its own (media_idx null) leaves the current media
         alone rather than snapping back to index 0. */
      if (showMedia && typeof v.media_idx === 'number' && v.media_idx >= 0) {
        showMedia(v.media_idx);
      }

      /* ITEM 8: keep the stock chip in sync with the SELECTED variant.
         ROUND 88: states come from the one rule above (isPreorder); the old
         title-based pre-order test is gone, and sold out reads "Sold out" here
         exactly as it does in the Liquid first paint. */
      var state, label;
      if (!v.available)                                  { state = 'out'; label = 'Sold out'; }
      else if (isPreorder)                               { state = 'pre'; label = 'Pre-order'; }
      else if (v.tracked && v.policy !== 'continue' && v.qty > 0 && v.qty <= 5) { state = 'low'; label = 'Only ' + v.qty + ' left'; }
      else                                               { state = 'in';  label = 'In stock'; }

      /* ROUND 88 T2 — "usually ships same or next business day" is shown only
         for in-stock Forged items. Every element carrying that claim on the PDP
         (the trust strip's shipping item and the sentence in the Shipping &
         Support tab) is marked [data-frg-ship-claim]; Collective products never
         emit the marker at all (they get the partner line server-side). */
      var claimOn = (state === 'in' || state === 'low');
      document.querySelectorAll('[data-frg-ship-claim]').forEach(function (el) { el.hidden = !claimOn; });

      var ship = document.querySelector('.frg-ship');
      if (ship) {
        ship.className = 'frg-ship frg-ship--' + state;
        var shipLabel = ship.querySelector('.frg-ship__label');
        var shipSub = ship.querySelector('.frg-ship__sub');
        if (shipLabel) {
          shipLabel.textContent = label;
        }
        /* ROUND 20 (Emirali: "Bro pre orders say 2-4 days"): a pre-order gets
           NO timing information — no ship time, no delivery window, nothing
           beyond the pre-order label. Previously only 'out' suppressed this,
           so every pre-order variant still advertised a ship time it cannot
           honour. Must stay in sync with the same rule in
           snippets/forged-shipping-status-inline.liquid, which handles first
           paint; this handles variant switching. */
        if (shipSub) shipSub.style.display = (state === 'out' || state === 'pre') ? 'none' : '';
      }
      /* reflect variant in URL without reload */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* noop */ }
    }

    pdp.querySelectorAll('.frg-pdp__opt-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var row = pill.closest('[data-frg-option-index]');
        row.querySelectorAll('.frg-pdp__opt-pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        updateVariant();
      });
    });
    pdp.querySelectorAll('[data-frg-opt-select]').forEach(function (sel) {
      sel.addEventListener('change', updateVariant);
    });

    /* ---------- ITEM 1: custom dropdown ----------
       The visible UI is fully custom; the native <select> stays visually hidden
       and remains the source of truth. Selecting a custom option writes into the
       select and re-dispatches `change`, so updateVariant() and every other
       consumer keep working untouched. */
    pdp.querySelectorAll('[data-frg-dd]').forEach(function (dd) {
      var trigger = dd.querySelector('[data-frg-dd-trigger]');
      var list = dd.querySelector('[data-frg-dd-list]');
      var valueEl = dd.querySelector('[data-frg-dd-value]');
      var sel = pdp.querySelector('[data-frg-opt-select="' + dd.dataset.frgDdFor + '"]');
      if (!trigger || !list || !sel) return;
      var opts = Array.prototype.slice.call(list.querySelectorAll('[data-frg-dd-opt]'));

      function close() {
        dd.classList.remove('is-open');
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
      function open() {
        /* only one dropdown open at a time */
        pdp.querySelectorAll('[data-frg-dd].is-open').forEach(function (o) {
          if (o !== dd) {
            o.classList.remove('is-open');
            o.querySelector('[data-frg-dd-list]').hidden = true;
            o.querySelector('[data-frg-dd-trigger]').setAttribute('aria-expanded', 'false');
          }
        });
        dd.classList.add('is-open');
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
      function choose(value) {
        opts.forEach(function (o) {
          var on = o.dataset.frgDdOpt === value;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (valueEl) valueEl.textContent = value;
        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        close();
      }

      trigger.addEventListener('click', function () {
        dd.classList.contains('is-open') ? close() : open();
      });
      opts.forEach(function (o) {
        o.addEventListener('click', function () { choose(o.dataset.frgDdOpt); });
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
        if (e.key === 'Escape') close();
      });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      /* keep the custom label honest if anything else changes the select */
      sel.addEventListener('change', function () { if (valueEl) valueEl.textContent = sel.value; });
    });

    /* ---------- quantity ---------- */
    var qtyEl = pdp.querySelector('[data-frg-qty-val]');
    var qtyNote = pdp.querySelector('[data-frg-qty-note]');

    /* Clamp qty to the current variant's cap and reflect it in the UI.
       Called on every +/- press and on every variant switch. */
    function applyCap() {
      var cap = capFor(curVariant);
      if (cap !== null && qty > cap) { qty = cap; }
      if (qty < 1) qty = 1;
      if (qtyEl) qtyEl.textContent = qty;

      /* Explain on REACHING the ceiling, not only when a value got clamped.
         First version only spoke on a clamp, which meant the common path was
         silent: the + button disables at the cap, so pressing it again did
         nothing and said nothing — exactly the "silently ignored click" this
         was meant to avoid. Caught by real clicking, not by review.

         Gated on qty > 1 so a stock-of-1 product doesn't shout on page load,
         where the quantity starts at the cap and the shopper has done nothing.
         The "Only 1 left" ship badge already covers that case. */
      var atCap = (cap !== null && qty >= cap);
      if (qtyNote) {
        if (atCap && qty > 1) {
          qtyNote.textContent = 'Only ' + cap + ' left — that’s the most you can add.';
          qtyNote.hidden = false;
        } else {
          qtyNote.hidden = true;
        }
      }
      /* Disable the + button at the ceiling so the control reads as capped
         rather than merely unresponsive. */
      var plus = pdp.querySelector('[data-frg-qty="1"]');
      if (plus) plus.disabled = (cap !== null && qty >= cap);
    }

    pdp.querySelectorAll('[data-frg-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        qty = Math.max(1, qty + parseInt(btn.dataset.frgQty, 10));
        applyCap();
      });
    });

    /* ---------- add to cart ---------- */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = pdp.dataset.frgVariant;
        if (!id || addBtn.disabled) return;
        /* Clamp the request itself, not just the widget. The stepper is the
           only way to change qty on this PDP today (it renders a <span>, not a
           number input), but clamping here means a stale qty from a variant
           switch — or any future typed input — can never be sent over the cap.

           ROUND 37 correction: the original note here said "Shopify still
           enforces the real limit server-side". That is false for /cart/add.js
           — measured, a 99-unit add of a 1-in-stock DENY variant returned HTTP
           200. Only change.js enforces. So this clamp is not belt-and-braces
           over a server guarantee; on the add path it IS the guard. The cap is
           also handed to ForgedCart.addItem so the choke point can re-apply it
           for any future caller. */
        applyCap();
        addBtn.classList.add('is-loading');
        function done() { addBtn.classList.remove('is-loading'); }
        var capNow = capFor(curVariant);   /* null = deliberately uncapped */
        /* ROUND 70 — tell the cart this variant is backordered before the line
           exists. The drawer's list of backordered ids is rendered by Liquid at
           page load, so a variant added by AJAX afterwards is not in it, and
           nothing client-side can look the answer up: /cart.js and
           /products/<handle>.js both omit inventory_quantity and
           inventory_policy. The PDP already holds that data for every variant,
           so it is the one place that can close the gap — and this is the route
           a backordered item is actually bought through. */
        if (curVariant && window.ForgedCart && window.ForgedCart.markBackordered) {
          window.ForgedCart.markBackordered(
            curVariant.id,
            /* ROUND 88: same pre-order rule as updateVariant (tag OR tracked +
               CONTINUE + qty <= 0, and buyable), so the drawer's "Pre-order"
               label matches the PDP. */
            !!(curVariant.available && (PREORDER_TAG ||
               (curVariant.tracked && curVariant.policy === 'continue' && curVariant.qty <= 0)))
          );
        }
        if (window.ForgedCart && window.ForgedCart.addItem) {
          window.ForgedCart.addItem({
            id: parseInt(id, 10),
            quantity: qty,
            max: (typeof capNow === 'number' ? capNow : undefined)
          });
          setTimeout(done, 800);
        } else {
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(id, 10), quantity: qty })
          }).then(function () { window.location.href = '/cart'; });
        }
      });
    }

    /* ---------- ROUND 64: sticky mobile add-to-cart ----------
       The real button sits ~1,669px down at 375. This surfaces price and a buy
       control once that button scrolls away.

       MIRRORS rather than reimplements. Price and sale state are copied from
       [data-frg-price]; label and disabled state from the real add button; a
       tap forwards to addBtn.click(). Everything variant-related therefore
       keeps working — the Round 30 cap, the 422 surfacing inside
       ForgedCart.addItem, the confirmation animation — with no second code
       path to drift.

       Sync is a MutationObserver on the real controls rather than a hook
       inside updateVariant(), so this block stays additive: nothing above it
       had to change, and if this whole feature were deleted the variant logic
       is untouched. */
    /* Queried from the document, NOT from `pdp`. The bar renders at the end of
       the product <section>, outside the [data-frg-pdp] root this file scopes
       to — a position:fixed page-level element does not belong inside the
       product content tree. Scoping it to `pdp` returned null and silently
       skipped this entire block; caught on live because the bar never
       appeared. The MutationObserver below still watches `pdp`, which is
       correct: that is where the price and button actually live. */
    var satc = document.querySelector('[data-frg-satc]');
    if (satc && addBtn && window.IntersectionObserver) {
      var satcPrice = satc.querySelector('[data-frg-satc-price]');
      var satcAdd = satc.querySelector('[data-frg-satc-add]');

      function satcSync() {
        if (priceEl && satcPrice) {
          satcPrice.textContent = priceEl.textContent;
          satcPrice.classList.toggle('is-sale', priceEl.classList.contains('is-sale'));
        }
        if (satcAdd) {
          satcAdd.disabled = addBtn.disabled;
          satcAdd.textContent = addLabel ? addLabel.textContent : 'Add to cart';
        }
      }

      var satcShown = null;
      function satcShow(on) {
        /* ROUND 65: this used to write on EVERY call. It is driven from a
           scroll handler and from MutationObservers, so unconditional writes
           meant a DOM mutation on every scroll frame — and worse, an observer
           that watches these same attributes re-entered through its own write
           and froze the page in a microtask loop. Writing only on a real state
           change makes the function idempotent and the loop impossible.

           aria-hidden tracks visibility so the bar is not announced twice
           while the real button is still on screen. */
        if (satcShown === on) return;
        satcShown = on;
        satc.hidden = !on;
        satc.setAttribute('aria-hidden', on ? 'false' : 'true');
        document.body.classList.toggle('frg-satc-on', on);
      }

      new MutationObserver(satcSync).observe(pdp, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
      satcSync();

      if (satcAdd) {
        satcAdd.addEventListener('click', function () {
          if (addBtn.disabled) return;
          addBtn.click();
        });
      }

      /* Visibility is driven by the real button's own intersection, not a
         scroll threshold — page length varies enormously across this catalogue
         and a fixed offset would fire at the wrong moment on most of it. */
      var realBtnOnScreen = true;
      var footerGuardOnScreen = false;
      /* The consent check lives HERE, not in satcFromRect, because the
         IntersectionObserver below calls satcEvaluate directly and would
         otherwise show the bar under the banner by the other path. This is the
         single decision point — every route to visibility passes through it. */
      function satcEvaluate() {
        satcShow(!realBtnOnScreen && !footerGuardOnScreen && !consentBannerBlocks());
      }

      new IntersectionObserver(function (entries) {
        /* ROUND 65: this used to set realBtnOnScreen = entries[0].isIntersecting
           and evaluate from that. isIntersecting is false for a button that is
           merely BELOW the fold, so on every PDP load the observer declared the
           button "not on screen" and the bar appeared at scrollY 0, covering
           the page before the customer had scrolled at all. Caught in the
           after-screenshot for this round, then confirmed: scrollY 0, real
           button at top 1385, bar visible at top 743 with opacity 1.

           Round 64 fixed exactly this in the rect path with `r.bottom > 0`
           ("scrolled past", not merely off-screen) but left the observer
           computing its own answer, so the two disagreed and whichever ran
           last won. Round 64 also wrote unconditionally, which hid the
           disagreement behind repeated scroll writes; making satcShow
           idempotent exposed it.

           The observer is now a TRIGGER, not a second source of truth. One
           definition of the condition, in one place. */
        satcFromRect();
      }, { rootMargin: '0px 0px -8px 0px' }).observe(addBtn);

      /* Fallback path, and the reason it exists.

         IntersectionObserver is the right primary mechanism — it reports the
         real button's visibility rather than a scroll offset, which matters
         because page length varies hugely across this catalogue. But it does
         not fire in every environment: measured here, an observer on the real
         button produced ZERO callbacks, not even the initial one the spec
         requires, because a document that is not actually being presented does
         not run intersection observations. Any customer on a backgrounded or
         prerendered tab is in the same position.

         So visibility is also computed directly from the button's rect on
         scroll. This is NOT the fixed-offset approach that was rejected: it
         reads the real element's position, exactly the same signal IO gives,
         just sampled. rAF-throttled and passive so it costs nothing per frame,
         and when IO does work the two agree and this is simply redundant. */
      /* ROUND 65 — THE DEAD CLICK SOURCE.

         Measured on a first visit at 375 with consent unanswered: Shopify's
         cookie banner occupies the bottom 413px of an 812px viewport — 51% of
         the screen — and it is position:fixed, so it sits permanently over the
         sticky bar. Hit-tested at three points across the Add button, all three
         returned shopify-pc__banner__*; with the banner hidden as a control,
         all three returned our button. Every tap on that button was a dead
         click, and dead clicks have risen for four consecutive reports.

         Chosen fix: SUPPRESS THE BAR until consent is answered. Of the three
         options this is the only one that keeps the banner at full prominence,
         which is non-negotiable while a compliance audit is open. Raising the
         bar over the banner would cover a legally required notice. Floating it
         above the banner's 413px would park it mid-screen, still leave
         everything else under the banner unreachable, and break the moment
         Shopify changes the banner's height.

         Page content under the banner can be scrolled clear of it. The sticky
         bar is fixed, so it is the one control that can never escape — that is
         what this fixes. The cost is a delay of exactly one tap on the banner.

         Read from the banner's real geometry rather than the privacy API: the
         geometry IS the condition, it needs no API to have loaded, and it
         self-corrects the instant the banner goes. */
      function consentBannerBlocks() {
        var el = document.querySelector('.shopify-pc__banner__dialog, shopify-privacy-banner');
        if (!el) return false;
        var r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0) return false;
        /* Only suppress when it actually overlaps the strip the bar sits in. */
        return r.bottom > window.innerHeight - 90;
      }

      function satcFromRect() {
        var r = addBtn.getBoundingClientRect();
        /* "Out of view" means SCROLLED PAST, not merely off-screen. On page
           load the real button is 1,669px down — below the fold, therefore not
           visible — and treating that as "out of view" popped the bar up
           immediately on arrival, which the brief explicitly rules out. The
           bar is for customers who have scrolled past the button, so it waits
           until the button has left through the TOP of the viewport. */
        realBtnOnScreen = r.bottom > 0;
        var pay = document.querySelector('.frg-footer__pay');
        var pol = document.querySelector('.frg-footer__policies, .frg-footer__legal');
        function vis(el) {
          if (!el) return false;
          var b = el.getBoundingClientRect();
          return b.top < window.innerHeight && b.bottom > 0;
        }
        footerGuardOnScreen = vis(pay) || vis(pol);
        satcEvaluate();
      }
      /* Called straight from the scroll event, NOT via requestAnimationFrame.
         The first version latched a `ticking` flag and cleared it inside rAF —
         measured live, rAF never fired, so the flag stayed true and the handler
         never ran again after the first scroll. The bar froze. Any environment
         that throttles rAF (a background tab most obviously) would do the same
         to a real customer.

         Doing the work inline is cheap enough not to need the throttle: this
         reads three rects, and Round 56 measured this theme's scroll handlers
         at 0.25ms per event and concluded there was no thrash worth fixing. */
      window.addEventListener('scroll', satcFromRect, { passive: true });
      window.addEventListener('resize', satcFromRect, { passive: true });
      /* Re-evaluating on the consent event alone is NOT enough, and this was
         caught on live rather than reasoned about. Measured: at the instant
         visitorConsentCollected fires, Shopify's dialog is still in the DOM and
         still laid out, so a synchronous re-read still saw it and kept the bar
         hidden. Normally the next scroll would correct that — but the discount
         popup opens right after consent and locks scrolling, so no scroll event
         ever arrived and the bar stayed hidden for the rest of the session.
         Forcing one scroll event by hand showed it appear correctly at top 743,
         which isolated it to timing rather than the condition.

         So watch for the real teardown instead of guessing a delay, and stop
         watching as soon as the banner is actually gone. The 3s backstop
         disconnects the observer and re-evaluates once more, so a banner that
         is hidden by some route the observer misses still resolves. */
      document.addEventListener('visitorConsentCollected', function () {
        satcFromRect();
        /* Deliberately NOT an attribute observer over the body subtree. The
           first version was, and it re-entered through satcShow's own writes
           and froze the page. childList only, and satcShow is now idempotent,
           so neither half of that can recur.

           Staged re-checks cover the case where Shopify hides the dialog with
           a class or style instead of removing the node, which childList
           cannot see. Four cheap rect reads, once per session, then done. */
        [150, 400, 900, 2000].forEach(function (ms) { setTimeout(satcFromRect, ms); });
        if (!window.MutationObserver) return;
        var mo = new MutationObserver(function () {
          satcFromRect();
          if (!consentBannerBlocks()) mo.disconnect();
        });
        mo.observe(document.body, { childList: true });
        setTimeout(function () { mo.disconnect(); satcFromRect(); }, 3000);
      });
      satcFromRect();

      /* Second guard: stand down entirely once the footer payment row or the
         policy links come into view, so the bar can never sit over them. The
         chat launcher's dodge (forged-chat-dodge.js) already treats
         .frg-footer__pay as a protected target for the same reason — this
         cooperates with that rather than fighting it. */
      var payRow = document.querySelector('.frg-footer__pay');
      var policyRow = document.querySelector('.frg-footer__legal, .frg-footer__policies');
      [payRow, policyRow].forEach(function (el) {
        if (!el) return;
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) footerGuardOnScreen = true;
          else if (!payRow || !policyRow) footerGuardOnScreen = false;
          else {
            var a = payRow.getBoundingClientRect(), b = policyRow.getBoundingClientRect();
            footerGuardOnScreen = (a.top < window.innerHeight && a.bottom > 0) ||
                                  (b.top < window.innerHeight && b.bottom > 0);
          }
          satcEvaluate();
        }).observe(el);
      });
    }

    /* ---------- gallery ---------- */
    var gallery = pdp.querySelector('[data-frg-gallery]');
    if (gallery) {
      var mains = Array.prototype.slice.call(gallery.querySelectorAll('[data-frg-main]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-frg-thumb]'));
      var idx = 0;
      function show(i) {
        idx = (i + mains.length) % mains.length;
        mains.forEach(function (m, mi) { m.classList.toggle('is-active', mi === idx); });
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === idx); });
      }
      /* ROUND 23: expose to updateVariant() so choosing a colourway actually
         changes the photo — see the hoisted declaration at the top of init(). */
      showMedia = show;
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.frgThumb, 10)); }); });
      var prev = gallery.querySelector('[data-frg-gallery-prev]');
      var next = gallery.querySelector('[data-frg-gallery-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });

      /* zoom modal */
      mains.forEach(function (m) {
        m.addEventListener('click', function () {
          var src = m.dataset.frgZoom;
          if (!src) return;
          var modal = document.createElement('div');
          modal.className = 'frg-zoom';
          modal.innerHTML = '<button class="frg-zoom__close" aria-label="Close">✕</button><img src="' + src + '" alt="">';
          document.body.appendChild(modal);
          document.body.classList.add('forged-scroll-lock');
          function close() { modal.remove(); document.body.classList.remove('forged-scroll-lock'); }
          modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('frg-zoom__close')) close(); });
          document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
        });
      });
    }

    updateVariant();
  }

  /* ==================================================================
     ROUND 67 — PDP tabs.

     Replaces four stacked accordions, two of which were open by default and
     together occupied 2,347px. Only the active panel renders now.

     Panels are hidden with the `hidden` attribute and never removed or lazily
     injected, so all four content areas stay in the DOM and remain indexable.

     Deep links resolve by ELEMENT, not by matching a list of known ids: any
     hash pointing at something inside a panel activates that panel. That covers
     #frg-panel-reviews, Judge.me's own #judgeme_product_reviews, and any anchor
     a future widget invents, without maintaining a mapping that could rot.
     ================================================================== */
  function initTabs() {
    var root = document.querySelector('[data-frg-tabs]');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-frg-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-frg-panel]'));
    if (!tabs.length || !panels.length) return;

    function panelFor(tab) { return document.getElementById(tab.getAttribute('aria-controls')); }

    function activate(tab, focusTab) {
      if (!tab) return;
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('is-active', on);
        /* Roving tabindex: only the active tab is in the tab order, so Tab
           moves past the bar rather than through every tab in it. */
        if (on) { t.removeAttribute('tabindex'); } else { t.setAttribute('tabindex', '-1'); }
        var p = panelFor(t);
        if (p) { if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); } }
      });
      if (focusTab) tab.focus();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        else return;
        e.preventDefault();
        activate(next, true);
      });
    });

    function activateFromHash() {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      var target;
      try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (err) { return; }
      if (!target) return;
      /* The target may BE a panel or live inside one. Reveal it first, because
         closest() still works on a hidden element but scrolling to it does not. */
      var panel = target.closest ? target.closest('[data-frg-panel]') : null;
      if (!panel) return;
      var owner = tabs.filter(function (t) { return t.getAttribute('aria-controls') === panel.id; })[0];
      if (!owner) return;
      activate(owner, false);
      /* Now that the panel is visible the anchor has a real position. */
      if (target.scrollIntoView) target.scrollIntoView({ block: 'start' });
    }

    activateFromHash();
    window.addEventListener('hashchange', activateFromHash);

    /* ROUND 84 — the star badge under the title jumps to the reviews.
       Judge.me's own badge handler scrolls to its widget, but the widget sits in
       a tab panel that is usually hidden, so on its own it goes nowhere. These
       listeners run in the CAPTURE phase so the Reviews tab is revealed before
       Judge.me's inner handler fires; both then scroll to the same place. */
    var reviewsLink = document.querySelector('[data-frg-reviews-link]');
    if (reviewsLink) {
      var openReviews = function () {
        var target = document.getElementById('judgeme_product_reviews');
        var panel = target && target.closest ? target.closest('[data-frg-panel]') : null;
        if (!panel) return;
        var owner = tabs.filter(function (t) { return t.getAttribute('aria-controls') === panel.id; })[0];
        if (!owner) return;
        activate(owner, false);
        target.scrollIntoView({ block: 'start' });
      };
      reviewsLink.addEventListener('click', openReviews, true);
      reviewsLink.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') openReviews();
      }, true);
    }
  }

  function boot() {
    init();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
